import { LDFlagSet } from '@launchdarkly/react-sdk';
import { dashCaseToCamelCase } from './dashCaseToCamelCase';

export function legacyDashCaseObjectKeysToCamelCase<T extends object>(obj: LDFlagSet): T {
  const newObj: Record<string, unknown> = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key)) {
      const newKey = dashCaseToCamelCase(key);
      newObj[newKey] = obj[key];
    }
  }
  return newObj as T;
}
